import {combineReducers} from "redux";
import tiendasReducer from "./tiendasReducer";
import usoCFDIReducer from "./usoCFDIReducer";
import regimenFiscalReducer from "./regimenFiscalReducer";
import facturacionReducer from "./facturacionReducer";
import busquedaReducer from "./busquedaReducer";
import busquedaFacturaReducer from "./busquedaFacturaReducer";
import busquedaReciboReducer from "./busquedaReciboReducer";

const allReducers = combineReducers({
        tiendas: tiendasReducer,
        usoCFDI: usoCFDIReducer,
        regimenFiscal: regimenFiscalReducer,
        facturacion: facturacionReducer,
        parametrosBusqueda: busquedaReducer,
        facturas: busquedaFacturaReducer,
        recibos: busquedaReciboReducer
    }
);

export default allReducers;